import { render, staticRenderFns } from "./assignPermission.vue?vue&type=template&id=8d4eb914"
import script from "./assignPermission.vue?vue&type=script&lang=js"
export * from "./assignPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports